/**
 * Ítems seleccionables en los buscadores de la venta.
 *
 * Regresión SUNAT 2026: la API de facturación creaba ítems de catálogo sin descripción
 * cuando una línea viajaba vacía. Esos ítems aparecían en los buscadores como filas en
 * blanco y se podían seleccionar, así que la línea salía sin descripción otra vez y el
 * comprobante se rechazaba (tenancy_kuntespa B001-1756/1757/1758/1759).
 *
 * Estos helpers viven acá (y no dentro de cada componente) para poder testearlos sin Vue.
 * El backstop sigue estando en facturación y en el BFF; esto corta el problema en el origen.
 */

/**
 * Descripción usable de un ítem del catálogo: `name` si tiene, si no `description`.
 *
 * @param {object} item
 * @returns {string} descripción sin espacios en los extremos, o '' si no hay ninguna
 */
const descripcionItem = (item) => {
    if (!item || typeof item !== 'object') return ''

    for (const campo of ['name', 'description', 'second_name']) {
        const valor = item[campo]
        if (typeof valor === 'string' && valor.trim() !== '') return valor.trim()
    }

    return ''
}

/**
 * ¿El ítem se puede ofrecer en el buscador? Un ítem sin descripción no aporta nada al
 * comprobante y lo hace rechazar.
 *
 * @param {object} item
 * @returns {boolean}
 */
const esItemSeleccionable = (item) => descripcionItem(item) !== ''

/**
 * Filtra la lista que devuelve el buscador, descartando los ítems sin descripción.
 *
 * @param {Array} lista
 * @returns {Array}
 */
const filtrarItemsSeleccionables = (lista) => (Array.isArray(lista) ? lista.filter(esItemSeleccionable) : [])

module.exports = { descripcionItem, esItemSeleccionable, filtrarItemsSeleccionables }
